<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <main-sub-page-toolbar icon="mdi-package-variant">{{
              $t("dashboardCardSuperAdminDelivery")
            }}</main-sub-page-toolbar>
          </v-flex>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <div>
              <data-table-search-toolbar
                :search.sync="search"
              ></data-table-search-toolbar>
              <v-data-table
                :loading-text="$t('lmPleaseWait')"
                class="#505050--text"
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? 'border: 1px solid darkgray; border-top: none; background-color: white'
                    : 'border: none; background-color: white'
                "
                :headers="headers"
                :items="$store.state.storeDelivery.delivery"
                :search="search"
                sort-by="name"
                :items-per-page="-1"
                must-sort
                show-expand
                :no-results-text="$t('dataGridSlotNoResults')"
                :no-data-text="$t('dataGridSlotNoData')"
                :footer-props="{
                  itemsPerPageText: $t('dataGridRowsPerPageText'),
                  itemsPerPageAllText: $t('dataGridRowsPerPageAllText'),
                }"
              >
                <template v-slot:expanded-item="{ item }">
                  <td :colspan="headers.length">
                    <span
                      class="mr-2"
                      v-for="i in item.selectedPaymentTypes"
                      :key="i.selectedPaymentTypes"
                    >
                      <v-chip color="secondary">
                        {{
                          deliveryTypeItems.find((item) => item.type == i).title
                        }}
                      </v-chip>
                    </span>
                  </td>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div class="d-flex flex-no-wrap">
                    <v-icon class="mr-3" @click="copyItem(item)"
                      >mdi-content-copy</v-icon
                    >
                    <v-icon class="mr-3" @click="editItem(item)"
                      >mdi-pencil</v-icon
                    >
                    <v-icon @click="deleteItemSet(item.id)">mdi-delete</v-icon>
                  </div>
                </template>
                <template v-slot:item.showAddress="{ item }">
                  <v-icon :color="item.showAddress ? 'success' : 'error'">
                    {{
                      item.showAddress
                        ? "mdi-check-circle-outline"
                        : "mdi-close-circle-outline"
                    }}
                  </v-icon>
                </template>
                <template v-slot:item.mapLink="{ item }">
                  <a :href="item.mapLink" v-if="item.mapLink !== ''">
                    <img style="height: 24px" src="@/assets/map-icon.png" />
                  </a>
                </template>
              </v-data-table>
            </div>
            <!-- DELETE CONFIRM DIALOG -->
            <dialog-basic-yes-no
              :active="dialogDelete"
              @clickYes="deleteItem"
              @clickNo="dialogDelete = false"
              icon="mdi-comment-question-outline"
              :title="$t('msgQuestion')"
              >{{ $t("deleteDialogQuestion") }}</dialog-basic-yes-no
            >
          </v-flex>
          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.push({ name: 'settingsSubMenu' })"
          ></simple-navigation-button>
          <!-- ADD / EDIT DIALOG -->
          <v-dialog
            v-model="dialog"
            max-width="500px"
            persistent
            transition="dialog-bottom-transition"
          >
            <template v-slot:activator="{ on }">
              <v-btn color="primary" v-on="on" dark fixed bottom right rounded>
                <v-icon medium class="mr-1">mdi-plus</v-icon>
                {{ $t("lmBtnAdd") }}
              </v-btn>
            </template>
            <v-form ref="form" v-model="valid">
              <v-card
                :class="
                  getTheme() == 'dark'
                    ? 'outlined elevation-0'
                    : 'flat elevation-0'
                "
                :style="
                  getTheme() == 'dark'
                    ? ''
                    : 'border-bottom: 1px solid lightgray'
                "
              >
                <v-card-title
                  :style="
                    getTheme() == 'dark'
                      ? 'background-color: #505050'
                      : 'background-color: white; border-bottom: 1px solid lightgray'
                  "
                  :class="
                    getTheme() == 'dark' ? 'white--text' : '#505050--text'
                  "
                  class="title font-weight-regular"
                >
                  <v-icon
                    :class="
                      getTheme() == 'dark' ? 'white--text' : 'primary--text'
                    "
                    class="mr-3"
                    medium
                  >
                    {{ this.editedIndex == -1 ? "mdi-plus" : "mdi-pencil" }}
                  </v-icon>
                  {{ formTitle }}
                </v-card-title>
                <v-card-text class="py-0 pt-2">
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field
                          v-model="editedItem.name"
                          :label="$t('settingsDeliveryGridHeaderDeliveryTitle')"
                          :rules="[validateRequired(), validateMaxLength(100)]"
                          :counter="100"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-select
                          v-model="editedItem.selectedPaymentTypes"
                          :items="deliveryTypeItems"
                          item-text="title"
                          item-value="type"
                          deletable-chips
                          small-chips
                          attach
                          chips
                          :label="
                            $t('settingsDeliveryGridHeaderPaymentTypesTitle')
                          "
                          multiple
                          dense
                        ></v-select>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="editedItem.extraCharge"
                          :label="$t('settingsDeliveryGridHeaderExtraPayTitle')"
                          :rules="[
                            validateRequired(),
                            validateIsCurrency(),
                            validateMaxLength(20),
                          ]"
                          :counter="20"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="editedItem.extraChargeMessage"
                          :label="
                            $t('settingsDeliveryGridHeaderExtraPayMessageTitle')
                          "
                          :rules="[validateMaxLength(100)]"
                          :counter="100"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="editedItem.extraChargeFreeOver"
                          :label="
                            $t(
                              'settingsDeliveryGridHeaderExtraPayFreeOverTitle'
                            )
                          "
                          :rules="[
                            validateRequired(),
                            validateIsCurrency(),
                            validateMaxLength(20),
                          ]"
                          :counter="20"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="editedItem.taxPct"
                          :label="$t('settingsPhotoOrderBasicTaxTitle')"
                          :rules="[
                            validateRequired(),
                            validateIsPercent(),
                            validateMaxLength(3),
                          ]"
                          :counter="3"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="editedItem.email"
                          :label="$t('settingsDeliveryGridHeaderEmailTitle')"
                          :rules="[
                            validateRequired(),
                            validateIsEmail(),
                            validateMaxLength(100),
                          ]"
                          :counter="100"
                          dense
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                          v-model="editedItem.mapLink"
                          :label="$t('settingsDeliveryGridHeaderMapTitle')"
                          :hint="$t('settingsDeliveryGridHeaderMapHint')"
                          :rules="[validateMaxLength(350)]"
                          :counter="350"
                          dense
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs12>
                        <v-switch
                          dense
                          style="height: 30px"
                          class="ma-0 pa-0"
                          v-model="editedItem.showAddress"
                          :label="
                            $t('settingsDeliveryGridHeaderShowAddressTitle')
                          "
                        ></v-switch>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions
                  :class="
                    getTheme() == 'dark' ? '#505050--text' : '#505050--text'
                  "
                  :style="
                    getTheme() == 'dark'
                      ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
                      : 'background-color: white; border-top: 1px solid lightgray;'
                  "
                >
                  <v-spacer></v-spacer>
                  <v-btn color="primary" class="my-1" text @click="close">
                    {{ $t("addEditFormCancelButton") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn @click="save" color="primary" dark>
                    <v-icon medium class="mr-1">mdi-content-save</v-icon>
                    {{ $t("addEditFormSaveButton") }}
                  </v-btn>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-dialog>
          <v-snackbar
            v-model="$store.state.storeSnackbar.snackbar.active"
            :color="$store.state.storeSnackbar.snackbar.color"
            :timeout="$store.state.storeSnackbar.snackbar.timeout"
            >{{ $store.state.storeSnackbar.snackbar.message }}</v-snackbar
          >
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import AppNavigation from "@/views/AppNavigation";
import MainSubPageToolbar from "@/components/MainSubPageToolbar";
import DialogBasicYesNo from "@/components/DialogBasicYesNo";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";
import DataTableSearchToolbar from "@/components/DataTableSearchToolbar";

export default {
  name: "settingsDelivery",
  components: {
    AppNavigation,
    MainSubPageToolbar,
    DialogBasicYesNo,
    SimpleNavigationButton,
    DataTableSearchToolbar,
  },
  data() {
    return {
      valid: true,
      netBackImage: require("@/assets/netBack.png"),
      search: "",
      dialog: false,
      dialogDelete: false,
      dialogDeleteId: "",
      headers: [
        {
          text: this.$t("settingsDeliveryGridHeaderDeliveryTitle"),
          align: "center",
          value: "name",
          sortable: true,
        },
        {
          text: this.$t("settingsDeliveryGridHeaderExtraPayTitle"),
          align: "center",
          value: "extraCharge",
          sortable: false,
        },
        {
          text: this.$t("settingsDeliveryGridHeaderExtraPayMessageTitle"),
          align: "left",
          value: "extraChargeMessage",
          sortable: false,
        },
        {
          text: this.$t("settingsDeliveryGridHeaderExtraPayFreeOverTitle"),
          align: "center",
          value: "extraChargeFreeOver",
          sortable: false,
        },
        {
          text: this.$t("settingsPhotoOrderBasicTaxTitle"),
          align: "center",
          value: "taxPct",
          sortable: false,
        },
        {
          text: this.$t("settingsDeliveryGridHeaderEmailTitle"),
          align: "left",
          value: "email",
          sortable: true,
        },
        {
          text: this.$t("settingsDeliveryGridHeaderMapTitle"),
          align: "center",
          value: "mapLink",
          sortable: false,
        },
        {
          text: this.$t("settingsDeliveryGridHeaderShowAddressTitle"),
          align: "center",
          value: "showAddress",
          sortable: true,
        },
        {
          text: "",
          align: "center",
          sortable: false,
          value: "actions",
        },
        {
          text: this.$t("settingsDeliveryGridHeaderPaymentTypesShortTitle"),
          value: "data-table-expand",
        },
      ],
      editedIndex: -1,
      editedItem: {
        id: "",
        name: "",
        selectedPaymentTypes: [],
        client: this.$store.state.storeClient.client.basicSettings.name,
        extraCharge: 0,
        extraChargeMessage: "",
        extraChargeFreeOver: 0,
        taxPct: 22,
        mapLink: "",
        email: "",
        showAddress: false,
      },
      defaultItem: {
        id: "",
        name: "",
        selectedPaymentTypes: [],
        client: this.$store.state.storeClient.client.basicSettings.name,
        extraCharge: 0,
        extraChargeMessage: "",
        extraChargeFreeOver: 0,
        taxPct: 22,
        mapLink: "",
        email: "",
        showAddress: false,
      },
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("addEditFormAddingTitle")
        : this.$t("addEditFormEditingTitle");
    },
  },
  methods: {
    deleteItemSet(item) {
      this.dialogDelete = true;
      this.dialogDeleteId = item;
    },
    async deleteItem() {
      try {
        await this.$store.dispatch("removeDelivery", this.dialogDeleteId);
        this.dialogDelete = false;
        this.dialogDeleteId = "";
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
      this.$store.commit({
        type: "showSnackbar",
        color: "success",
        message: this.$t("msgSuccessDelete"),
      });
    },
    copyItem(item) {
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    editItem(item) {
      this.editedIndex = this.$store.state.storeDelivery.delivery.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },
    async save() {
      if (this.$refs.form.validate()) {
        if (this.editedIndex > -1) {
          try {
            await this.$store.dispatch("editDelivery", this.editedItem);
            this.$store.commit({
              type: "showSnackbar",
              color: "success",
              message: this.$t("msgSuccessEdit"),
            });
          } catch (error) {
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: error,
            });
          }
        } else {
          try {
            await this.$store.dispatch("addDelivery", this.editedItem);
            this.$store.commit({
              type: "showSnackbar",
              color: "success",
              message: this.$t("msgSuccessAdd"),
            });
          } catch (error) {
            this.$store.commit({
              type: "showSnackbar",
              color: "error",
              message: error,
            });
          }
        }
        this.close();
      }
    },
  },
};
</script>
